import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseAPIService {

  public apiUrlAuth = environment.apiUrl;

  private apiEndpointToken: string = '';

  constructor(
    private http: HttpClient
  ) { }

  setApiEndpointToken(token: string) {
    this.apiEndpointToken = token;
  }

  filter(
    filter: string = '[]',
    orderBy: string = '[]',
    pageNumber: number = 0,
    pageSize: number = 10,
    apipath: string = '',
    type: string = '',
    apiAuth: 'auth' | 'unauth' = 'unauth'
  ): Observable<any> {

    let params = new HttpParams()
      .set('filter', filter)
      .set('orderBy', orderBy)
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('type', type);

    const baseUrl = this.apiUrlAuth;

    const url = `${baseUrl}/api/unauth/${apipath}`

    return this.http.get<any>(url, { params }).pipe(
      catchError(this.handleError('filter', []))
    );
  }

  // ─────────────────────────────────────────────────────────
  // 🔥 ERROR HANDLER
  // ─────────────────────────────────────────────────────────
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(`❌ ${operation} failed:`, error);
      return of(result as T);
    };
  }

  public getWallartByImageId(imageId: string, userId: number = 0): Observable<any> {
    const url =
      `${this.apiUrlAuth}/api/unauth/wallart-search-by-image-id` +
      `?image_id=${imageId}&user_id=${userId}&more_products=1`;
    return this.http.get<any>(url).pipe(
      catchError(this.handleError('getWallartByImageId', null))
    );
  }

  public getWallartProducts(
    sub_cat_slug: string,
    color: string,
    orientation: string,
    art_type: string,
    subject: string,
    page: number,
    per_page: number,
    cat_slug: string,
    contributor_code: string,
    skipLoader = false,
    sortby: string = 'created_at',
    sortdir: string = 'desc'
  ): Observable<any> {

    let params = new HttpParams();

    if (skipLoader) {
      params = params.append('skipLoader', 'true');
    }

    const baseUrl = this.apiUrlAuth;

    const user_id = 0;

    const url =
      `${baseUrl}/api/unauth/wallart-search-by-collection` +
      `?cat_slug=${cat_slug}` +
      `&sub_cat_slug=${sub_cat_slug}` +
      `&color=${color}` +
      `&orientation=${orientation}` +
      `&art_type=${art_type}` +
      `&keyword=${subject}` +
      `&contributor_code=${contributor_code}` +
      `&page=${page}` +
      `&per_page=${per_page}` +
      `&user_id=${user_id}` +
      `&sortby=${sortby}` +
      `&sortdir=${sortdir}`;

    return this.http.get<any>(url, { params }).pipe(
      catchError(this.handleError('getWallartProducts', []))
    );
    
  }

}